import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Error404 = (props) => {
   const tokenDetailsString = sessionStorage.getItem('userDetails');
   let tokenDetails = JSON.parse(tokenDetailsString);

   return (
      <div className="fix-wrapper">
         <div className="container">
            <div className="row justify-content-center">
               <div className="col-md-6">
                  <div className="form-input-content text-center error-page">
                     <h1 className="error-text font-weight-bold">404</h1>
                     <h4>
                        <i className="fa fa-exclamation-triangle text-warning" />{" "}
                        The page you were looking for is not found!
                     </h4>
                     <p>
                        You may have mistyped the address or the page may have
                        moved.
                     </p>
                     <div>
                        <Link className="btn btn-primary" to={(tokenDetails && tokenDetails.token) ? "/home":"/login"}>
                           Back to Home
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Error404;
